import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material'
class MessageData {
  public title?: string
  public message?: string
}

@Component({ templateUrl: 'message.dialog.html' })
export class MessageDialog {
  constructor(
    public dialogRef: MatDialogRef<MessageDialog>,
    @Inject(MAT_DIALOG_DATA)
    public data: MessageData
  ) { }
}
